// [S-090c] Contract Classification — platform_admin admin surface.
//
// The platform-canonical catalog (categories / contract types / CBAs /
// facets / legacy aliases) that the ingestion pipeline + upload portal
// share. The tabbed CRUD lives in the shared <ClassificationCatalog>
// (S-320c); this screen is the platform-scoped wrapper. Its tenant sibling
// is TenantClassification.tsx at /settings/classification.
//
// Every write requires platform_admin server-side; the route guard in
// App.tsx mirrors that for the navigation graph.
import { PageHead } from "../components";
import { ClassificationCatalog } from "./ClassificationCatalog";

export function Classification(): JSX.Element {
  return (
    <>
      <PageHead
        eyebrow="Platform · contract classification"
        title={
          <>
            One vocabulary, <em>everywhere.</em>
          </>
        }
        sub="Categories, contract types, CBAs, and facets the ingestion pipeline + upload portal share. Edits propagate to Stage 2 LLM extraction on the next ingestion run."
      />
      <ClassificationCatalog scope="platform" />
    </>
  );
}
